import { zodResolver } from "@hookform/resolvers/zod";
import { useForm } from "react-hook-form";

import {
  OpenCustomerInstructionData,
  openCustomerInstructionSchema,
} from "../OpenCustomerInstructionForm.schema";

export function useOpenCustomerInstructionForm(
  initialData?: Record<string, unknown>
) {
  return useForm<OpenCustomerInstructionData>({
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    resolver: zodResolver(openCustomerInstructionSchema) as any,
    defaultValues: {
      header: typeof initialData?.header === "string" ? initialData.header : "",
      main: typeof initialData?.main === "string" ? initialData.main : "",
    },
  });
}
